export const ASSIGNEE = 'assignee'; // only for AssignmentRemoval
export const AUDIT = 'audit';
export const MEMBERS = 'members';
export const THREAD_REMOVAL_TYPE = '@type';